import { Component, EventEmitter, Output } from '@angular/core';
import { FormBuilder, FormGroup, Validators, ReactiveFormsModule } from '@angular/forms';
import { AlertService } from '../../../alert.service';
import { NgbActiveModal, NgbPopover } from '@ng-bootstrap/ng-bootstrap';
import { FeatureGroupTemplateService } from '../../services/feature-group-template.service';
import { faQuestionCircle } from '@fortawesome/free-solid-svg-icons';
import { FaIconComponent } from '@fortawesome/angular-fontawesome';
import { NgFor } from '@angular/common';

@Component({
    selector: 'app-feature-group-template-selection',
    templateUrl: './feature-group-template-selection.component.html',
    styleUrls: ['./feature-group-template-selection.component.css'],
    imports: [ReactiveFormsModule, NgFor, NgbPopover, FaIconComponent]
})
export class FeatureGroupTemplateSelectionComponent {

  proposalForm!: FormGroup;
  templateProposals: any[] = [];
  faQuestionCircle = faQuestionCircle;

  @Output() select: EventEmitter<any> = new EventEmitter<any>();

  constructor(
    private alertService: AlertService,
    private fb: FormBuilder,
    private featureGroupTemplateService: FeatureGroupTemplateService,
    public modal: NgbActiveModal,) { }

  ngOnInit(): void {
    this.proposalForm = this.fb.group({
      featureGroupTemplateId: ['', Validators.required],
      isPriceUpdate: [false, Validators.required],
    });
    this.getProposalTemplate();
  }

  getProposalTemplate(){
    this.featureGroupTemplateService.getProposalTemplates().subscribe((data: any) => {
      this.templateProposals = data;
      if(data.length > 0){
        this.proposalForm.controls['featureGroupTemplateId'].setValue(data[0].groupTemplateId);
      }
    })
  }

  selectProposalTemplate(){
    if(this.proposalForm.valid){
      this.select.emit(this.proposalForm.value);
      this.closeModal();
    }

  }

  closeModal(){
    this.modal.close();
  }

}
